checkOnline = ->
  return navigator.onLine unless navigator.connection? and window.Connection?

  currentNetworkState = navigator.connection.type

  states = {}
  states[Connection.UNKNOWN]  = false
  states[Connection.NONE]     = false
  states[Connection.ETHERNET] = true
  states[Connection.WIFI]     = true
  # In iOS, all cellular connection defaults to Connection.CELL
  states[Connection.CELL]     = true
  states[Connection.CELL_2G]  = true
  states[Connection.CELL_3G]  = true
  states[Connection.CELL_4G]  = true

  !! states[currentNetworkState]

module.exports = {
  checkOnline
}